import { Component, OnInit, ViewChild, TemplateRef, EventEmitter, Inject, LOCALE_ID, Output, Input } from '@angular/core';
import { FarrisSectionComponent } from '@farris/ui-section';
import { ProcessListHelpService } from '../../services/process-list-help.service';
import { MessagerService } from '@farris/ui-messager';
import { NotifyService } from '@farris/ui-notify';
import { BsModalService, BsModalRef } from '@farris/ui-modal';
import { FrameworkService } from '@gsp-sys/rtf-common';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from '@farris/ui-loading';
import { Observable, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { IRtProcQueryParam } from '../../entity/IProcQueryParam';
import { BifMetadataType } from '../../entity/BifMetadataType';
import { ProcessFilterConditionArgs } from '../../entity/ProcessFilterConditionArgs';
import { TextValue } from '@edp-bif/common-api';
import { OrderByDirection } from '../../entity/OrderByDirection';
import { DatagridComponent } from '@farris/ui-datagrid';
import { RtBillProcessListResult } from '../../entity/RtBillProcessListResult';
import { AifLocalePipe, BIF_LANG_RESOURCES } from '../../../aif-ui-common/pipe/aif-ui-common-locale.pipe';
import { AIF_PROCESS_LIST_HELP_LANG_RESOURCES } from '../../i18n/lang.resource';

@Component({
  selector: 'app-process-list-help',
  templateUrl: './process-list-help.component.html',
  styleUrls: ['./process-list-help.component.css'],
  providers: [
    { provide: BIF_LANG_RESOURCES, useValue: AIF_PROCESS_LIST_HELP_LANG_RESOURCES },
    AifLocalePipe,
  ]
})
export class ProcessListHelpComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(data: any) {
    if (data) {
      this.processCode = data;
      this.setProcess.code = this.processCode;
      this.setProcess.showText = this.processCode;
    }
  }

  @Input() editorParams: {
    bizTypeId?: string
  } = {};

  private processCode: string;
  modalConfig = {
    title: this.localePipe.transform("creationProcess"),
    width: 1250,
    height: 500,
    showButtons: true
  };

  procEmitter = new EventEmitter<any>();
  queryParam: IRtProcQueryParam;

  @ViewChild("tt")
  tt: DatagridComponent;
  ttIdField: string = "id";
  ttData: any[] = [];
  ttColumns: any[] = [];
  cascadeCheck = false;
  cascadeDown = false;
  cascadeUp = false;
  @ViewChild('nameCellTemp')
  nameCellTemp: TemplateRef<any>;

  @ViewChild('iconSelectFooter')
  modalFooter: TemplateRef<any>;

  modalRef: BsModalRef;

  readonly defaultPageSize: number = 30;
  pageList = [this.defaultPageSize, 50, 100, 200, 500];

  /**
   * 已设置流程
   */
  setProcess: {
    code?: string;
    name?: string;
    showText?: string;
  } = {
      showText: ""
    };

  constructor(
    private procHelpService: ProcessListHelpService,
    private messager: MessagerService,
    private notify: NotifyService,
    private modalService: BsModalService,
    private frameworkService: FrameworkService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loading: LoadingService,
    @Inject(LOCALE_ID) localeId: string,
    private localePipe: AifLocalePipe,
  ) {
    this.queryParam = this.createDefaultQueryParam();
  }

  ngOnInit() {
    this.configTtColumns();
    // if (this.editorParams && this.editorParams.bizTypeId) {
    //   this.queryParam.filterArgs.bizType = new TextValue();
    //   this.queryParam.filterArgs.bizType.value = this.editorParams.bizTypeId;
    //   this.queryParam.filterArgs.bizType.hasValue = true;
    // }
    if (this.processCode != null) {
      this.procHelpService.getProcessNameByCode(this.processCode).subscribe(
        (processName) => {
          this.setProcess.name = processName;
          if (this.setProcess.name) {
            this.setProcess.showText = `${this.setProcess.name}(${this.setProcess.code})`;
          } else {
            this.setProcess.showText = this.setProcess.code;
          }
        }
      );
    }
    this.loadItems(this.queryParam.filterArgs).subscribe(() => {
      setTimeout(() => {
        if (this.ttData && this.ttData.length > 0) {
          const proc = this.processCode != null ? this.ttData.find((it) => it.code == this.processCode) : this.ttData[0];
          proc && this.tt.selectRow(proc.id);
        }
      }, 300);
    });
  }

  clickOk(evt?) {
    if (this.tt.selectedRow == null) {
      this.notify.warning(this.localePipe.transform("pleaseSelectOneItemOnly"));
      return;
    }
    this.procEmitter.emit(this.tt.selectedRow.data);
    const object = { value: this.tt.selectedRow.data.code, parameters: null };
    this.submitModal.emit(object);
    this.modalRef && this.modalRef.close();
  }

  clickCancel(evt?) {
    this.procEmitter.complete();
    this.closeModal.emit();
    this.modalRef && this.modalRef.close();
  }

  onSearch(param: any) {
    this.queryParam = param;
    console.log(this.queryParam);
    this.loadItems(this.queryParam.filterArgs).subscribe(
      () => {
        this.tt.clearCheckeds();
        this.tt.clearSelections();
      }
    );
  }

  clickNameCell(ctx) {
    this.procHelpService.openBifManagerApp(ctx.rowData);
  }

  onPageSizeChanged($event: { pageIndex: number, pageSize: number }) {
    // console.log('PageSize Changed:', $event);
    let checkedIds = this.tt.checkeds.map(r => r.data.id);

    this.queryParam.filterArgs.pageSize = $event.pageSize;
    this.loadItems(this.queryParam.filterArgs).subscribe(
      () => {
        setTimeout(() => {
          this.tt.checkRows(checkedIds, true);
          this.tt.refresh();
        }, 0);
      }
    );
  }

  onPageChanged($event: { pageIndex: number, pageSize: number }) {
    // console.log('PageNumber Changed:', $event);
    let checkedIds = this.tt.checkeds.map(r => r.data.id);

    this.queryParam.filterArgs.pageIndex = $event.pageIndex - 1;
    this.queryParam.filterArgs.pageSize = $event.pageSize;
    this.loadItems(this.queryParam.filterArgs).subscribe(
      () => {
        setTimeout(() => {
          this.tt.checkRows(checkedIds, true);
          this.tt.refresh();
        }, 0);
      }
    );
  }

  pageChangeHandler(pageInfo: { pageIndex: number, pageSize: number }) {
    let checkedIds = this.tt.checkeds.map(r => r.data.id);

    this.queryParam.filterArgs.pageIndex = pageInfo.pageIndex - 1;
    this.queryParam.filterArgs.pageSize = pageInfo.pageSize;
    this.loadItems(this.queryParam.filterArgs).subscribe(
      () => {
        setTimeout(() => {
          this.tt.checkRows(checkedIds, true);
          this.tt.refresh();
        }, 0);
      }
    );
  }

  pageSizeChangeHandler(size: number) {
    let checkedIds = this.tt.checkeds.map(r => r.data.id);

    this.queryParam.filterArgs.pageSize = size;
    this.loadItems(this.queryParam.filterArgs).subscribe(
      () => {
        setTimeout(() => {
          this.tt.checkRows(checkedIds, true);
          this.tt.refresh();
        }, 0);
      }
    );
  }

  removeSetProcess() {

  }

  private loadItems(args: ProcessFilterConditionArgs): Observable<any> {
    const loadingComp = this.loading.show({ message: this.localePipe.transform("loading") });
    return this.procHelpService.getDatagridData(args).pipe(
      switchMap(
        (listRes: RtBillProcessListResult) => {
          this.ttData = [...listRes.entities];
          //更新分页信息
          this.tt.setPageIndex(listRes.pageIndex + 1);
          this.tt.total = listRes.totalCount;
          this.tt.pageSize = listRes.pageSize;
          // this.page.setCurrentPage(this.paginationId, listRes.pageIndex + 1);
          // this.page.setItemsPerPage(this.paginationId, listRes.pageSize);
          // this.page.setTotalItems(this.paginationId, listRes.totalCount);

          loadingComp.close();
          return of(listRes);
        }
      ),
      catchError(
        (err) => {
          loadingComp.close();
          setTimeout(() => {
            //todo 确定异常结构, 目前采用兼容取值方式
            this.messager.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
          }, 300);
          throw err;
        }
      )
    );
  }

  private configTtColumns() {
    this.ttColumns = [
      // {
      //   field: "isEnabled", title: this.localePipe.transform("enabledState"), width: 100, sortable: false,
      //   formatter: (value: boolean, rowData, rowIndex) => {
      //     if (value == true) {
      //       return this.localePipe.transform("enabled");
      //     } else if (value == false) {
      //       return this.localePipe.transform("disabled");
      //     } else {
      //       return "-";
      //     }
      //   }
      // },
      { field: "code", title: this.localePipe.transform("code"), width: 120, sortable: true },
      {
        field: "name", title: this.localePipe.transform("name"), width: 250, sortable: true,
        template: this.nameCellTemp,
      },
      { field: "upBillVoName", title: this.localePipe.transform("upBill"), width: 120, sortable: true },
      { field: "downBillVoName", title: this.localePipe.transform("downBill"), width: 120, sortable: true },
      // {
      //   field: "bifMetadataType", title: this.localePipe.transform("processType"), width: 120, sortable: false,
      //   formatter: (value: BifMetadataType, rowData, rowIndex) => {
      //     if (value == BifMetadataType.BifCreationProcess) {
      //       return this.localePipe.transform("creation");
      //     } else if (value == BifMetadataType.BifWritebackProcess) {
      //       return this.localePipe.transform("writeback");
      //     } else {
      //       return "-";
      //     }
      //   }
      // },
      {
        field: "sysInit", title: this.localePipe.transform("sysInit"), width: 80, sortable: false,
        formatter: (value: boolean, rowData, rowIndex) => {
          if (value == true) {
            return this.localePipe.transform("yes");
          } else if (value == false) {
            return this.localePipe.transform("no");
          } else {
            return "-";
          }
        }
      },
      // {
      //   field: null, title: this.localePipe.transform("isExtendProcess"), width: 80, sortable: false,
      //   formatter: (value: boolean, rowData, rowIndex) => {
      //     if (rowData.parentId == null) {
      //       return this.localePipe.transform("no");
      //     } else {
      //       return this.localePipe.transform("yes");
      //     }
      //   }
      // },
      // { field: "businessType", title: this.translateService.instant("businessType"), width: 120 },
      // { field: "creator", title: this.translateService.instant("creator"), width: 120 },
      // { field: "createdTime", title: this.translateService.instant("createdTime"), width: 120 },
      // { field: "lastModifier", title: this.translateService.instant("lastModifier"), width: 120 },
      // {
      //   field: "lastModifiedTime", title: this.localePipe.transform("lastModifiedTime"), width: 120, sortable: true,
      //   formatter: {
      //     type: 'datetime',
      //     options: {
      //       format: 'YYYY-MM-DD HH:mm:ss'
      //     }
      //   },
      // },
    ];
  }

  private createDefaultQueryParam() {
    const queryParam = {
      filterArgs: new ProcessFilterConditionArgs(),
      filterArgsExt: {}
    };

    queryParam.filterArgs.pageSize = this.defaultPageSize;
    queryParam.filterArgs.pageIndex = 0;
    queryParam.filterArgs.OrderByLastModifiedTime = new TextValue();
    queryParam.filterArgs.OrderByLastModifiedTime.value = OrderByDirection.Desc;
    queryParam.filterArgs.OrderByLastModifiedTime.hasValue = true;
    queryParam.filterArgs.billProcessType = new TextValue();
    queryParam.filterArgs.billProcessType.value = BifMetadataType.BifCreationProcess;
    queryParam.filterArgs.billProcessType.hasValue = true;
    queryParam.filterArgs.isEnabled = new TextValue();
    queryParam.filterArgs.isEnabled.value = "true";
    queryParam.filterArgs.isEnabled.hasValue = true;


    return queryParam;
  }
}
